import styled from 'styled-components';

import { mixins } from '@nhl/common-styled-component';

export const StanleyCupWinnerContainer = styled.div`
    .trophy-container {
        .trophy-overview-container {
            padding-top: 0px;
        }
    }

    .team-display-container .team-display .team-name {
        white-space: initial;
    }

    .ReactTable .rt-table .rt-thead.-header {
        ${mixins.desktopUp} {
            position: sticky;
            top: 80px;
        }
    }
`;

export const StanleyCupContentContainer = styled.div`
    .module {
        display: block;
        padding: 0px 20px;
    }
`;
